import React from "react";
import ReactDOM from "react-dom";
import App from "./App";
import * as serviceWorker from "./serviceWorker";
import { Provider } from "react-redux";
import { Router } from "react-router-dom";
import store from "./store";
import "bootstrap/dist/css/bootstrap.min.css";
import { history } from "./store";
import { createTheme as createMuiTheme, ThemeProvider } from '@mui/material/styles';

const theme = createMuiTheme({
  palette: {
    type: 'light',
    primary: {
      main: '#0B5394',
    },
    secondary: {
      main: '#E69138',
    },
    error: {
      main: '#E82A36',
    },
  },
  typography: {
    button: {
      textTransform: 'none',
    }
  },
  overrides: {
    MuiInput: {
      input: {
        "&::placeholder": {
          color: "var(--placeholder-text)",
          opacity: 1,
        },
      }
    },
  }
});

ReactDOM.render(
  <Provider store={store}>
    <Router history={history}>
      <ThemeProvider theme={theme}>
        <App history={history} />
      </ThemeProvider>
    </Router>
  </Provider>,
  document.getElementById("root")
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
